<template>
  <div id="app">
    <div class="header">
      <div class="header__info">
        <div class="language_switcher" @click="changeLocale">
          {{$t('nextLocaleName')}}
        </div>
      </div>
      <div class="header__title">
        {{$t('title')}}
      </div>
      <div class="header__description">
        <i18n path="description.text">
          <a
            href="https://www.researchgate.net/profile/Evgeniia_Georgievskaia/publication/338677920_Presentation_Lifetime_Calculator_Demo_version/links/5e238553299bf1e1fabd41a2/Presentation-Lifetime-Calculator-Demo-version"
            target="_blank">{{ $t('description.link') }}</a>
        </i18n>
      </div>
    </div>
    <router-view/>
    <div class="sponsors">
      {{$t('sponsors1')}} <br>
      {{$t('sponsors2')}}
    </div>
    <div class="ta-response-container">
      <el-button type="success" icon="el-icon-message" circle @click="openFeedbackModal">
<!--        {{$t('contactBtn')}}-->
      </el-button>
    </div>
    <FeedbackModal ref="feedbackModal" :visible="feedbackModalVisible"/>
  </div>
</template>

<script>
import I18nMixin from './i18n/i18n_mixin'
import FeedbackModal from './modals/FeedbackModal'

export default {
  mixins: [I18nMixin],
  components: {
    FeedbackModal
  },
  data () {
    return {
      feedbackModalVisible: false
    }
  },
  methods: {
    openFeedbackModal () {
      this.$refs.feedbackModal.open()
    }
  }
}
</script>

<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  html, body {
    background: #F1F6E4;
    height: 100%;
  }

  .sponsors {
    background: #E0F2D9;
    margin-bottom: 5pt;
    margin-top: 5pt;
  }

  .header {
    margin-bottom: 5pt;
    margin-top: 5pt;

    &__info {
      background: #E0F2D9;
      display: flex;
      flex-direction: row-reverse;
    }

    &__title {
      font-size: 18pt;
      padding: 20px 0;
      font-weight: bold;
    }
  }

  .language_switcher {
    margin: 3px;
    padding: 1px;
    cursor: pointer;
    background: #B9E0A3;
  }

  .ta-response-container {
    position: fixed;
    bottom: 20pt;
    right: 20pt;
    z-index: 999;
  }

</style>
